import type { ValidationCheck } from '../../types/checks.js';
import { colorProfileCheck } from '../colorProfileCheck.js';
import { dpiCheck } from '../dpiCheck.js';

/**
 * Technical file checks: dimensions, aspect ratio, format, size, colour profile
 * and DPI metadata.
 *
 * DPI here means "what the file states about its resolution", nothing else: it
 * is metadata reporting and never a failure on its own.
 */
export const TECHNICAL_CHECKS: readonly ValidationCheck[] = [dpiCheck, colorProfileCheck];
